<template>
  <div v-if="stipendRequest" class="activity-card" @click="handleClick">
    <div v-if="selected">
      <!-- class small-load-spinner is used to adjust the size of the loadspinner to fit the ActivityCard  -->
      <LoadSpinner :color="`#${organizationDetails.darkBrandColor}`" />
    </div>
    <template v-else>
      <div class="fcolumn" :class="{ mobile: !forceMobile }">
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name" v-translate>Program Month</div>
            <div class="field-value">{{ stipendRequest.programMonth }}</div>
          </div>
          <div class="form-field-container">
            <div class="field-name" v-translate>Amount</div>
            <div class="field-value">{{ stipendRequest.amount | currency }}</div>
          </div>

        </div>
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name">{{ $gettext('Status:') }}</div>
            <div class="field-value">
              {{ stipendRequest.status }}
            </div>
          </div>
          <div class="form-field-container">
            <div class="field-name" v-translate>Date</div>
            <div class="field-value">
              {{ this.stipendRequest.datetimeCreated | formatDateShort($language.current) }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="!forceMobile" class="hidden-mobile">
        <div class="frow tablet-desktop-activity" style="justify-content: space-between;">
          <div>{{ stipendRequest.programMonth }}</div>
          <div>{{ stipendRequest.amount | currency }}</div>
          <div>
            {{ stipendRequest.status }}
          </div>
          <div>
            {{ this.stipendRequest.datetimeCreated | formatDateShort($language.current) }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LoadSpinner from '@/components/LoadSpinner'
import SurveyResponse from '@/services/surveyresponses'
import { mapState } from 'vuex'
import StipendRequest from '@/services/stipendRequests'
export default {
  name: 'StipendRequestCard',
  components: {
    LoadSpinner,
  },
  data() {
    return {
      selected: false,
    }
  },
  props: {
    stipendRequest: {
      type: Object,
      required: true,
    },
    forceMobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.selected = true

      this.$store.dispatch('updateCurrentRequest', this.stipendRequest)

      if (this.stipendRequest.status === StipendRequest.options.STARTED) {
        if(this.stipendRequest.programMonth == 1) {
          this.$router.push({ name: 'NomineeOnboardingImpactStatement' })
        } else if(this.stipendRequest.programMonth == 13) {
          this.$router.push({
            name: 'NomineeYear2Application',
            params: {
              id: this.stipendRequest.id
            }
          })
        } else {
          this.$router.push({ name: 'StipendGoalProgression' })
        }
        return
      }

      this.$router.push({ name: 'StipendRequestSummary' })
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/flex-box';

.activity-card {
  cursor: pointer;
  padding: 1rem 0.5rem;

  &:hover {
    background-color: #f0f0f0;
  }
}

.form-field {
  padding: 0;
  margin-bottom: 1rem;

  .form-field-container {
    flex: 1;
  }

  &:last-of-type {
    margin-bottom: 0rem;
  }
}

.tablet-desktop-activity {
  div:nth-child(1) {
    width: 15%;
  }

  div:nth-child(2) {
    width: 35%;
  }

  div:nth-child(3) {
    width: 20%;
  }
}
</style>
